<template>
  <div class="card-presentation" >
    <div v-if="!hasCards" class="jumbotron">
      <h1 class="display-4">No flashcards yet!</h1>
      <p class="lead">Add a flashcard to it.</p>
    </div>
    <div v-if="hasCards" class="jumbotron">
      <div class="" v-if="currentView == 'question'">
        <h1 class="display-5">Question:</h1>
        <div class="body-text" v-if="!question.usesMarkdown">{{ question.body }}</div>
        <div class="body-text" v-if="question.usesMarkdown" v-html="question.body"></div>
        <p>
          <button type="button" class="btn btn-outline-secondary" v-on:click="revealAnswer" >Answer</button>
        </p>
      </div>
      <div class="" v-if="currentView == 'answer'">
        <h1 class="display-5">Answer:</h1>
        <div class="body-text" v-if="!answer.usesMarkdown">{{ answer.body }}</div>
        <div class="body-text" v-if="answer.usesMarkdown" v-html="answer.body"></div>
        <p>
          <button type="button" class="btn btn-outline-secondary" v-on:click="backToQuestion" >Back to Question</button>
        </p>
      </div>
      <p class="lead">Card {{ currentCardNum }} of total {{ totalCardNum }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardPresentation',
  props: ['hasCards', 'cardType', 'currentCardNum', 'totalCardNum', 'currentCard'],
  data: function(){
    return {
      currentView: "question"
    }
  },
  computed: {
    question() {
      return this.currentCard.question
    },
    answer() {
      return this.currentCard.answer
    }
  },
  methods: {
    revealAnswer(){
      this.currentView = "answer"
    },
    backToQuestion(){
      this.currentView = "question"
    }
  },
  watch: {
    currentCard(){
      this.currentView = "question"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .jumbotron {
    /* height: 30rem;
    overflow: scroll; */
    margin-bottom: 10rem;
  }
  .body-text {
    font-size: 1.5rem;
    margin-bottom: 2rem;
    white-space: pre-line;
    text-align: justify;
  }
</style>
